<template>
  <div>
    <CreateNavBar/>
    <div class="container">
      <CreateTitle :title="page_title"/>

      <div class="create">
        <loader :isLoading="isRequestInProgress"/>
        <div class="row">
          <div class="col-sm">
            <CreatePageImage :src="image.url" :alt="image.alt" :width="image.width"/>
          </div>

          <div class="col-sm form-container">
            <form @submit.prevent="submit" id="form-create" novalidate>
              <div class="type-of-account">
                <p>Choose type of account</p>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    v-model="formType"
                    type="radio"
                    name="for-create-account"
                    id="for-individual-create"
                    value="individual"
                    checked>
                  <label class="form-check-label" for="for-individual-create">
                    YeyPass for me
                  </label>
                  <small class="form-text text-muted radio-option-help">
                    Choose this if you will use YeyPass for yourself.
                  </small>
                </div>
                <br/>
                <div>
                  <label class="form-check-label" for="for-individual-create">
                    YeyPass for Business
                  </label>
                  <small class="form-text text-muted radio-option-help">
                    Choose this if you will use YeyPass for your establishments <br>
                    or if you are an event organizer who needs establishment pass.
                    <br>e.g For Buildings, Office, Hotels, Condos, Schools and etc.
                  </small>
                </div>
                <div>
                  <br/>
                  <a class="business-request-link" href="/request-demo">Request for Demo</a>
                </div>
              </div>

              <!-- For Establishment Owners -->
              <div id="establishment-signup-form" v-if="formType === 'business'">
                <InputComponent
                  type="text"
                  for="input-company-name"
                  label_text="Business Name"
                  attribute="Business Name"
                  placeholder="CompanyXYZ"
                  v-model="form.business.profile_details.company_name"
                  :v="$v.form.business.profile_details.company_name"
                />

                <InputComponent
                  type="email"
                  for="input-company-email"
                  label_text="Email Address"
                  attribute="Email Address"
                  placeholder="your@awesomecompany.com"
                  v-model="form.business.email_address"
                  :v="$v.form.business.email_address"
                />
                <small
                  v-if="fetchError && fetchError.account === 'business' && fetchError.error_type == 'email'"
                  data-type="message"
                  class="form-text text-muted error-message"
                  v-html="fetchError.error"
                ></small>

                <div class="form-group password">
                  <label for="input-company-password">Password</label>
                  <input
                    v-model="form.business.password"
                    data-vv-name="password"
                    type="password"
                    class="form-control"
                    placeholder="Password"
                    :v="$v.form.business.password"
                    @input="$v.form.business.password.$touch()"
                  >
                  <!--small class="form-text text-muted password-help">
                  Password should be at least 8 characters in length.
                  Contain at least 3 of the following type of characters: lower case, upper case, numbers, or special characters.
                  </small-->
                  <div v-if="$v.form.business.password.$dirty">
                    <small
                      class="form-text text-muted error-message"
                      v-if="!$v.form.business.password.required">
                      Password must not be empty.
                    </small>
                    <small
                      class="form-text text-muted password-help error-message"
                      v-if="!$v.form.business.password.minLength">
                      Password should be at least 8 characters in length.
                      <br>Contain at least 3 of the following type of characters: lower case, upper case, numbers, or special characters.
                    </small>
                  </div>
                  <small
                    v-if="fetchError && fetchError.account === 'business' && fetchError.error_type == 'password'"
                    data-type="message"
                    class="form-text text-muted error-message"
                    v-html="fetchError.error"
                  ></small>
                </div>

                <InputComponent
                  type="text"
                  for="input-contact-person"
                  label_text="Company Representative (Full Name)"
                  attribute="Company Representative"
                  placeholder="James Dean"
                  v-model="form.business.profile_details.contact_person"
                  :v="$v.form.business.profile_details.contact_person"
                />

                <InputComponent
                  type="text"
                  for="input-role"
                  label_text="Company Representative Role"
                  attribute="Company Representative Role"
                  placeholder="Admin Officer"
                  v-model="form.business.profile_details.role_in_company"
                  :v="$v.form.business.profile_details.role_in_company"
                />
              </div>
              <!-- Establishment Form Content Ends Here -->
              <!-- For Users -->
              <div id="users-signup-form" v-else>
                <InputComponent
                  type="text"
                  for="input-firstname"
                  label_text="First Name"
                  attribute="First Name"
                  placeholder="Juan"
                  v-model="form.individual.first_name"
                  :v="$v.form.individual.first_name"
                />

                <InputComponent
                  type="text"
                  for="input-lastname"
                  label_text="Last Name"
                  attribute="Last Name"
                  placeholder="Dela Cruz"
                  v-model="form.individual.last_name"
                  :v="$v.form.individual.last_name"
                />

                <InputComponent
                  type="email"
                  for="input-email"
                  label_text="Email Address"
                  attribute="Email Address"
                  placeholder="your@awesome.com"
                  v-model="form.individual.email_address"
                  :isDisabled="autoFillEmail"
                  :v="$v.form.individual.email_address"
                />

                <small
                  v-if="fetchError && fetchError.account === 'individual' && fetchError.error_type == 'email'"
                  data-type="message"
                  class="form-text text-muted error-message"
                  v-html="fetchError.error"
                ></small>

                <div class="form-group password">
                  <label for="input-password">Password</label>
                  <input
                    v-model="form.individual.password"
                    data-vv-name="password"
                    type="password"
                    class="form-control"
                    placeholder="Password"
                    :v="$v.form.individual.password"
                    @input="$v.form.individual.password.$touch()"
                  >
                  <!--small class="form-text text-muted password-help">
                  Password should be at least 8 characters in length.
                  Contain at least 3 of the following type of characters: lower case, upper case, numbers, or special characters.
                  </small-->
                  <div v-if="$v.form.individual.password.$dirty">
                    <small
                      class="form-text text-muted error-message"
                      v-if="!$v.form.individual.password.required">
                      Password must not be empty.
                    </small>
                    <small
                      class="form-text text-muted password-help error-message"
                      v-if="!$v.form.individual.password.minLength">
                      Password should be at least 8 characters in length.
                      <br>Contain at least 3 of the following type of characters: lower case, upper case, numbers, or special characters.
                    </small>
                  </div>
                  <small
                    v-if="fetchError && fetchError.account === 'individual' && fetchError.error_type == 'password'"
                    data-type="message"
                    class="form-text text-muted error-message"
                    v-html="fetchError.error"
                  ></small>
                </div>
              </div>
              <!-- Users Form Content Ends Here -->
              <!-- Submit Button -->

              <div class="text-center">
                <br/>
                <small class="form-text text-muted error-message" v-if="error.message">
                  {{ error.message }}
                </small>
                <button type="submit" class="btn btn-primary">Sign Up</button>
              </div>
            </form>

            <small class="form-text text-muted text-center">
              By signing up, you agree with our
              <a class="simple-link" href="/tos">Terms</a> and
              <a class="simple-link" href="/privacy">Privacy Policy</a>.
            </small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { REGISTER } from '@/store/types/actions.type'

import { required, email, minLength } from 'vuelidate/lib/validators'

// import rug from '../api/username_generator/'

import CreateNavBar from '@/components/common/CreateNavBar'
import CreateTitle from '@/components/common/CreateTitle'
import CreatePageImage from '@/components/common/CreatePageImage'
import Loader from '@/components/common/Loader'
import InputComponent from '@/components/form/InputComponent'

import { ASSET_CREATE_ACCOUNT } from '@/api/constants/ImageAssets'

import { APIService } from '@/api/APIService'
import { AuthService } from '@/api/AuthService'

const api = new APIService()
const auth = new AuthService()

export default {
  components: {
    CreateNavBar,
    CreateTitle,
    CreatePageImage,
    InputComponent,
    Loader
  },
  data() {
    return {
      page_title: 'Create Account',
      image: ASSET_CREATE_ACCOUNT,
      formType: 'individual',
      form: {
        business: {
          username: '',
          email_address: '',
          password: '',
          account_type: 'business',
          profile_details: {
            company_name: '',
            contact_person: '',
            role_in_company: ''
          }
        },
        individual: {
          username: '',
          email_address: '',
          password: '',
          account_type: 'individual',
          first_name: '',
          last_name: ''
        }
      },
      autoFillEmail: false,
      hasValidInvite: true,
      error: { message: '' },
      pageOrigin: '',
      route: '/upload-selfie'
    }
  },
  validations: {
    form: {
      business: {
        email_address: { required, email },
        password: { required, minLength: minLength(8) },
        profile_details: {
          company_name: { required },
          contact_person: { required },
          role_in_company: { required }
        }
      },
      individual: {
        email_address: { required, email },
        password: { required, minLength: minLength(8) },
        first_name: { required },
        last_name: { required }
      }
    }
  },
  computed: {
    ...mapGetters(['fetchError', 'registerFields', 'isRequestInProgress'])
  },
  mounted() {
    // TO REFACTOR THIS PART
    // if (Object.keys(this.registerFields).length !== 0) {
    //   if (this.registerFields.account_type === 'business') {
    //     this.form.business = this.registerFields
    //   } else {
    //     this.form.individual = this.registerFields
    //   }
    // }

    // do check if there's already someone loggedIn
    if(auth.getUserId()) {
      this.$router.push('/dashboard')
    } else {
      this.pageOrigin = this.$route.query.page_origin
      if (this.pageOrigin) {
        this.route = `/upload-selfie?page_origin=${this.pageOrigin}`
      }
    }

    const token = this.$route.query.t
    if(token) this.verifyToken(token)

  },
  methods: {
    submit() {
      if (this.formType === 'individual') {
        this.$v.form.individual.$touch()
        if (!this.$v.form.individual.$invalid) {
          return this.postFields()
        }
      }

      if (this.formType === 'business') {
        this.$v.form.business.$touch()
        if (!this.$v.form.business.$invalid) {
          return this.postFields()
        }
      }
    },
    async verifyToken(token) {
      const tokenParam = { t: token }
      const tokenResponse = await api.verifyInvite(tokenParam)
      // what to do if inviteToken not valid???
      if(tokenResponse.message) {
        this.error.message = 'Invite token is not valid'
        this.hasValidInvite = false
      } else if(tokenResponse.email_address) {
        this.form.individual.email_address = tokenResponse.email_address
        this.autoFillEmail = true
        this.hasValidInvite = true
      } else {
        this.error.message = 'Something went wrong'
        this.hasValidInvite = false
      }
    },
    postFields() {
      var self = this
      var fields = {}
      // const generatedUsername = rug.generate()

      if (this.formType === 'business') {
        const email = this.form.business.email_address
        this.form.business.email_address = email.toLowerCase()
        var businessFields = {
          ...this.form.business,
          // username: generatedUsername,
          account_type: this.formType,
          profile_details: {
            ...this.form.business.profile_details
          }
        }
        fields = businessFields
      } else {
        var firstName = this.form.individual.first_name
        var lastName = this.form.individual.last_name
        const email = this.form.individual.email_address
        this.form.individual.email_address = email.toLowerCase()

        var individualFields = {
          ...this.form.individual,
          // username: generatedUsername,
          account_type: this.formType,
          profile_details: {
            first_name: firstName,
            last_name: lastName
          }
        }
        fields = individualFields
      }

      this.$store.dispatch(REGISTER, fields)
      .then(data => { self.redirectToPage() })
      .catch(err => { self.error.message = err })
    },
    redirectToPage() {
      if (this.formType === 'business') {
        this.$router.push('/create-business-info')
      } else {
        this.$router.push(this.route)
      }
    }
  }
}
</script>

<style>
@import '../assets/styles/form-style-1.css';
</style>

<style type="text/css" scoped>
  .business-request-link {
    margin-top: 30px;
    margin-bottom: 10px;
    margin-left: 8px;
    border: none;
    background-color: #ffd630;
    color: #00386a;
    font-family: 'HKGrotesk-Bold', Helvetica, sans-serif;
    font-size: 16px;
    min-width: 200px;
    border-radius: 3px;
    padding: 10px 30px;
  }
</style>



// WEBPACK FOOTER //
// src/containers/CreateAccount.vue